export const STATE_IDLE = 0;
export const STATUS_LOADING = 1;
export const STATUS_SUCCESS = 2;
export const STATUS_ERROR = 3;